import AjusteVerba from '../../spa/orcamento/ajuste-verba/AjusteVerba';
import AjusteVerbaForm from '../../spa/orcamento/ajuste-verba/AjusteVerbaForm';

export default {
  path: 'ajuste-verba',
  name: 'ajuste-verba',
  component: AjusteVerba,
  children: [
    {
      path: 'novo',
      name: 'novoAjusteVerba',
      component: AjusteVerbaForm,
      props: {
        fluxo: false,
        somenteLeitura: false,
        novo: true,
      },
    },
    {
      path: ':id',
      name: 'verAjusteVerba',
      component: AjusteVerbaForm,
      props: {
        somenteLeitura: true,
        novo: false,
        fluxo: false,
      },
    },
    {
      path: ':id/fluxo',
      name: 'verAjusteVerbaFluxo',
      component: AjusteVerbaForm,
      props: {
        somenteLeitura: true,
        novo: false,
        fluxo: true,
      },
    },
  ],
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/config/router/ajuste-verba.js